module.exports = __webpack_public_path__ + "static/media/logo.92c4bae9.png";